/**
 * Utility
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type GeoJSONObjectType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const GeoJSONObjectType = {
    NUMBER_0: 0 as GeoJSONObjectType,
    NUMBER_1: 1 as GeoJSONObjectType,
    NUMBER_2: 2 as GeoJSONObjectType,
    NUMBER_3: 3 as GeoJSONObjectType,
    NUMBER_4: 4 as GeoJSONObjectType,
    NUMBER_5: 5 as GeoJSONObjectType,
    NUMBER_6: 6 as GeoJSONObjectType,
    NUMBER_7: 7 as GeoJSONObjectType,
    NUMBER_8: 8 as GeoJSONObjectType
};

